import React, { useEffect, useState, useContext } from 'react';

/** components */
import Footer from '../../components/common/Footer';
import Header from '../../components/common/Header';

/** helpers */
import TenantConfig from '../../config';

/** constants */
import cavenuesgrant from '../../constants/cavenuesgrant';

/** context */
import { UserContext } from '../../context/UserContext';
import { notificationTextCurrentDateInDateRange, sanitizeHtml } from '../../helpers/format';

/** service */
import { isCurrentDateInDateRange } from '../../helpers/format';
import { getLoanProducts, getPublicApplicationDetails } from '../../service/api';

export const getLoanProductInfo = async () => {
  const expiration_time = 10;
  const productInfoJson = localStorage.getItem('productInfo') || '';
  let productInfo = productInfoJson ? JSON.parse(productInfoJson) : {};
  const currentDate = new Date();
  if (
    productInfoJson &&
    productInfo.expirationDate &&
    currentDate.getTime() < productInfo.expirationDate
  ) {
    return productInfo;
  } else {
    //we make the API call here
    const res = await getPublicApplicationDetails();
    productInfo = res.data;
    const expirationDate = currentDate.setMinutes(currentDate.getMinutes() + expiration_time);
    productInfo.expirationDate = expirationDate;
    localStorage.setItem('productInfo', JSON.stringify(productInfo));
    return productInfo;
  }
};

const Landing = () => {
  const { landingHeaderBeakpoint } = useContext(UserContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [notificationText, setNotificationText] = useState('');
  const displayStyleForApplyButton = isButtonDisabled
    ? { display: 'none' }
    : { display: 'inline-block' };
  const displayStyleForSignInButton = notificationText?.includes(
    cavenuesgrant.notificationText?.startTime
  )
    ? { display: 'none' }
    : { display: 'inline-block' };
  useEffect(() => {
    async function getLoan() {
      try {
        let openProducts;
        try {
          const loanProducts = await getLoanProducts();
          if (loanProducts && loanProducts.data) {
            openProducts = loanProducts.data.filter((loan) => {
              return isCurrentDateInDateRange(loan.startDate, loan.endDate);
            });
          }
        } catch (getLoanProdErr) {
          console.log(getLoanProdErr);
        }
        //if no projet are availale then we disable the apply now
        //else at least one product is open then we show the apply
        if (openProducts?.length == 0) {
          const openProduct = openProducts[0];
          setIsButtonDisabled(true);
          const { text } = notificationTextCurrentDateInDateRange(
            openProduct.startDate,
            openProduct.endDate,
            'America/Los_Angeles',
            'PDT'
          );
          setNotificationText(text);
        } else {
          return;
        }
      } catch (e) {
        console.log(e);
        setIsButtonDisabled(true);
      }
    }

    getLoan();
  }, []);
  return (
    <div className="landing-page">
      <Header breakpoint={landingHeaderBeakpoint} />

      <>
        {/*----- Main Hero Section -----*/}
        <div
          className={'hero-section ' + cavenuesgrant.landingDetails?.className}
          style={{
            backgroundImage: `url(${cavenuesgrant.landingDetails?.backgroundImage})`,
          }}
        >
          {/*----- Center Piece -----*/}
          <div className={'center-piece'}>
            <div className={'center-piece-btns'}>
              {/*<h1>California Venues Grant Program</h1>*/}

              <div className={'headerTitle'}>California Venues Grant Programs</div>

              <button
                className="landing-outline-btn"
                style={displayStyleForApplyButton}
                onClick={() => (window.document.location.href = '/auth/register?app=/dashboard')}
              >
                Apply Now
              </button>
              <button
                className="landing-outline-btn"
                style={displayStyleForSignInButton}
                onClick={() => (window.document.location.href = '/auth/sign-in?app=/dashboard')}
              >
                Sign into Portal
              </button>
            </div>
          </div>

          {/*-----------   Hero footer -----------*/}
        </div>

        <div className={`landing-content ${TenantConfig.getTenant()}`}>
          <div className={'helpful-hints'}>
            {/*----- Program Help -----*/}
            <div className="eligibility">
              <div className="left-part">
                <h5>Program Help</h5>
              </div>
              <div className="center-part">
                <ul>
                  {cavenuesgrant.programGuideLineButtons.map((eligibility, index) => (
                    <div
                      className="landing-outline-btn eligibilty-btn "
                      key={'eligibility' + index}
                    >
                      <a href={eligibility.link} target="blank">
                        {eligibility.text}
                      </a>
                    </div>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/*-------------- Text Below Box -------------------------*/}
          <div className={'precondition'}>
            <div className={'precondition-title'}>The Review Process</div>
            <p>
              <div className={'precondition-content'}>
                <p>
                  <b>What is required for Lendistry to review my application?</b>
                  <span>{<br />}</span>For your application to be reviewed by Lendisry, the
                  following items must be completed in Lendistry's Portal:
                </p>
                <ol>
                  {cavenuesgrant.helpfulTips.map((tip, index) => (
                    <li key={'tip' + index}>{tip}</li>
                  ))}
                </ol>
                <p>
                  <b>How will you know if your application was submitted?</b>
                  <span>{<br />}</span>You will receive a confirmation email from Lendistry at
                  noreply@lendistry.com to confirm your application has been received. If you did
                  not receive a confirmation email after submitting your application, please check
                  your spam folder for emails from noreply@lendistry.com and add the email address
                  to your email account’s safe sender list.
                </p>
                <p>
                  If more information or documents are needed, Lendistry may contact you by email,
                  phone, and/or text (if authorized) to verify the information you submitted. You
                  must respond to all requests to keep your application in the review process.
                </p>
                <p>
                  <b>How will you know if you were awarded a grant? </b>
                  <span>{<br />}</span>The application process for this program contains multiple
                  stages of validation. You must first meet the program’s minimum eligibility
                  requirements in order to be considered for a grant. Important Note: Meeting the
                  minimum eligibility requirements does not guarantee a grant award.
                </p>
                <p>
                  Once you are determined to be eligible for this program, your application will
                  then go through final validation to determine if you are approved or declined for
                  funding. As part of this validation process, you will be required to confirm
                  certain information live over the telephone. A member of Lendistry’s team will
                  reach out to you directly to complete this process.
                </p>
                <p>
                  Once your application is fully validated, you will receive an email from Lendistry
                  to notify you if you have been approved or declined for grant funding.
                </p>
              </div>
            </p>
          </div>
        </div>
      </>
      <Footer breakpoint={landingHeaderBeakpoint} />
    </div>
  );
};

export default Landing;
